(() => {
  const selector = '[data-botox-use-demo]';

  function init(root) {
    if (root.dataset.botoxUseReady === 'true') return;
    root.dataset.botoxUseReady = 'true';

    const video = root.querySelector('[data-botox-use-video]');
    const toggle = root.querySelector('[data-botox-use-toggle]');
    if (!video || !toggle) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let hydrated = false;
    let inView = false;

    const setControl = (playing) => {
      toggle.textContent = playing ? 'Pausar' : 'Reproducir';
      toggle.setAttribute('aria-label', playing ? 'Pausar demostración' : 'Reproducir demostración');
    };

    const hydrate = () => {
      if (hydrated) return;
      const poster = video.dataset.poster;
      if (poster) video.poster = poster;
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.load();
      hydrated = true;
    };

    const play = () => {
      hydrate();
      const result = video.play();
      if (result && typeof result.catch === 'function') result.catch(() => setControl(false));
    };

    toggle.addEventListener('click', () => {
      if (!hydrated || video.paused) play();
      else video.pause();
    });
    video.addEventListener('play', () => setControl(true));
    video.addEventListener('pause', () => setControl(false));

    const observe = (entry) => {
      inView = entry.isIntersecting;
      if (inView) {
        if (!reducedMotion.matches) play();
        else {
          hydrate();
          setControl(false);
        }
      } else if (!video.paused) video.pause();
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => entries.forEach(observe), {
        rootMargin: '0px 0px 120px 0px',
        threshold: 0.15
      });
      observer.observe(root);
    } else {
      hydrate();
      setControl(false);
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden && !video.paused) video.pause();
      else if (!document.hidden && inView && !reducedMotion.matches) play();
    });
    reducedMotion.addEventListener?.('change', () => {
      if (reducedMotion.matches && !video.paused) video.pause();
      else if (!reducedMotion.matches && inView) play();
    });
    setControl(false);
  }

  const boot = () => document.querySelectorAll(selector).forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
